export const readerPath = (roomCode) => `/room/${encodeURIComponent(roomCode)}`;

export const readerUrl = (roomCode, windowRef = window) =>
  new URL(readerPath(roomCode), windowRef.location.origin).href;

// Clipboard is not available in every iPad/Safari context. Keep the fallback
// synchronous and use the supplied references so it is easy to test.
export async function copyText(text, {
  navigatorRef = typeof navigator !== 'undefined' ? navigator : undefined,
  documentRef = typeof document !== 'undefined' ? document : undefined,
  } = {}) {
  if (navigatorRef?.clipboard?.writeText) {
    try {
      await navigatorRef.clipboard.writeText(text);
      return true;
    } catch (error) {
      // Safari can expose Clipboard API but reject the write because the page
      // is not in an allowed gesture/permission context. Continue to the
      // textarea path instead of making the user retry manually.
    }
  }

  if (!documentRef?.body || typeof documentRef.execCommand !== 'function') {
    return false;
  }

  const textarea = documentRef.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  documentRef.body.appendChild(textarea);
  textarea.select();
  let copied = false;
  try {
    copied = documentRef.execCommand('copy');
  } finally {
    documentRef.body.removeChild(textarea);
  }
  return copied;
}

export async function copyReaderLink(roomCode, refs) {
  const url = readerUrl(roomCode, refs?.windowRef);
  const copied = await copyText(url, refs);
  return { copied, url };
}
